export const COMMON_FONT_SIZES = {
  xs: "10px",
  sm: "12px",
  md: "14px",
  lg: "18px",
  xl: "24px",
};

export const COMMON_MARGIN_SIZES = {
  xs: "4px",
  sm: "8px",
  md: "12px",
  lg: "16px",
};

export const COMMON_PADDING_SIZES = {
  xs: "4px",
  sm: "8px",
  md: "12px",
  lg: "16px",
};
